import { ArrowLeft } from "feather-icons-react/build/IconComponents";
import { t } from "i18next";
import { useEffect, useState } from "react";
import API from "../../API/newIndex";
import Breadcrumbs from "../../controllers/breadCrumbs";
import { parentNavigate } from "../../controllers/ParentNavigate";
import ButtonComponent from "../FormInput/ButtonComponent";
import InputComponent from "../FormInput/InputComponent";
import Notification from "../Notification";

const GoogleCustomeSetting = ({ installedExtensions }) => {
  console.log(installedExtensions, "installedExtensions");
  const extentionId = installedExtensions?.find(
    (item) => item?.extension_name === "Google Analytics",
  );
  console.log(extentionId, "extentionId");
  const [isNotification, setIsNotification] = useState(false);
  const [notificationMsg, setNotificationMsg] = useState("");
  const [severity, setSeverity] = useState();
  const [errors, setErrors] = useState({});

  const [form, setForm] = useState({
    privateKey: "",
    clientEmail: "",
    apiKey: "",
    propertyId: "",
    googleTag: "",
  });

  const getGoogleSignup = async (superExtId) => {
    const idToUse = superExtId || extentionId?.super_extension_id;
    if (!idToUse) return;

    try {
      const apicall = await API({
        url: `/admin/extension/GetExtensionWithCredentials/${idToUse}`,
        method: "get",
      });

      const resData = apicall?.data || apicall;
      const credentials = resData?.credentials || resData?.data?.credentials || [];
      if (Array.isArray(credentials)) {
        const mappedForm = {
          privateKey: credentials.find((c) => c.secret_key === "private_key")?.secret_value || "",
          clientEmail: credentials.find((c) => c.secret_key === "client_email")?.secret_value || "",
          apiKey: credentials.find((c) => c.secret_key === "api_key")?.secret_value || "",
          propertyId: credentials.find((c) => c.secret_key === "property_id")?.secret_value || "",
          googleTag: credentials.find((c) => c.secret_key === "google_tag")?.secret_value || "",
        };

        setForm(mappedForm);
      }
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg("Failed to fetch credentials");
      setSeverity("error");
    }
  };

  useEffect(() => {
    if (extentionId?.super_extension_id) {
      getGoogleSignup(extentionId?.super_extension_id);
    }
  }, [extentionId?.super_extension_id]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));

    // remove error when user types
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validate = () => {
    const newErrors = {};

    if (!form.privateKey.trim()) {
      newErrors.privateKey = "Private key is required";
    }

    if (!form.clientEmail.trim()) {
      newErrors.clientEmail = "Client email is required";
    } else if (!/^\S+@\S+\.\S+$/.test(form.clientEmail)) {
      newErrors.clientEmail = "Enter a valid email address";
    }

    if (!form.apiKey.trim()) {
      newErrors.apiKey = "API key is required";
    }

    if (!form.propertyId.trim()) {
      newErrors.propertyId = "Property ID is required";
    }

    if (!form.googleTag.trim()) {
      newErrors.googleTag = "Google tag is required";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    const payload = {
      credentials: [
        { secret_key: "private_key", secret_value: form.privateKey },
        { secret_key: "client_email", secret_value: form.clientEmail },
        { secret_key: "api_key", secret_value: form.apiKey },
        { secret_key: "property_id", secret_value: form.propertyId },
        { secret_key: "google_tag", secret_value: form.googleTag },
      ],
    };

    try {
      await API({
        url: `/admin/extension/updateExtension/${extentionId?.super_extension_id}`,
        method: "put",
        data: payload,
      });

      setIsNotification(true);
      setNotificationMsg("Google Analytics credentials updated successfully");
      setSeverity("success");

      getGoogleSignup(extentionId?.super_extension_id); // refresh data
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg("Failed to update credentials");
      setSeverity("error");
    }
  };

  const handleClose = () => {
    setIsNotification(false);
    setNotificationMsg("");
    setSeverity("");
  };
  return (
    <>
      {isNotification && notificationMsg && (
        <Notification message={notificationMsg} close={handleClose} severity={severity} />
      )}
      <div className="h-auto overflow-y-auto overflow-x-hidden pb-[64px] p-[20px]">
        <div className="flex items-center space-x-2 pb-[20px]">
          <button
            onClick={(e) => {
              e.preventDefault();
              parentNavigate("/dashboard");
            }}
            className="back-arrow"
          >
            <ArrowLeft />
          </button>
          <div>
            <Breadcrumbs
              crumbs={[
                { name: t("lang_dashboard"), path: `/dashboard` },
                { name: t("lang_Google_Analytics_Settings"), path: "/GoogleCustomeSetting" },
              ]}
            />
            <h4 className="text-xl md:text-2xl font-semibold text-primary">
              {t("lang_Google_Analytics_Settings")}{" "}
            </h4>
          </div>
        </div>
        <div className="grid grid-cols-1">
          <div className="secondary-bg-color rounded-[6px] mb-4 shadow overflow-x-auto overflow-y-hidden">
            <div className="p-5">
              <h6 className="text-xl md:text-2xl font-semibold text-primary">
                {t("lang_Google_Analytics_Credentials")}
              </h6>
              <hr className="my-4 main-border-color" />

              <form onSubmit={handleSubmit} className="w-full">
                {/* Private Key */}
                <div className="mb-4">
                  <label>
                    Private Key <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    rows={4}
                    name="privateKey"
                    value={form.privateKey}
                    onChange={handleChange}
                    placeholder="Enter private key"
                    className={`w-full rounded-md border px-4 py-2 text-sm outline-none ${errors.privateKey ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:border-black focus:ring-black"}`}
                  />
                  {errors.privateKey && (
                    <p className="text-xs text-red-500 mt-1">{errors.privateKey}</p>
                  )}
                </div>

                {/* Client Email */}
                <div className="mb-4">
                  <InputComponent
                    label="Client Email"
                    required
                    name="clientEmail"
                    type="email"
                    value={form.clientEmail}
                    onChange={handleChange}
                    placeholder="Enter client email"
                    error={errors.clientEmail}
                  />
                </div>

                {/* API Key */}
                <div className="mb-4">
                  <InputComponent
                    label="API Key"
                    required
                    name="apiKey"
                    type="text"
                    value={form.apiKey}
                    onChange={handleChange}
                    placeholder="Enter api key"
                    error={errors.apiKey}
                  />
                </div>

                {/* Property ID */}
                <div className="mb-4">
                  <InputComponent
                    label="Property Id"
                    required
                    name="propertyId"
                    type="text"
                    value={form.propertyId}
                    onChange={handleChange}
                    placeholder="Enter property id"
                    error={errors.propertyId}
                  />
                </div>

                {/* Google Tag */}
                <div className="mb-6">
                  <InputComponent
                    label="Google Tag"
                    required
                    name="googleTag"
                    type="text"
                    value={form.googleTag}
                    onChange={handleChange}
                    placeholder="Enter google tag"
                    error={errors.googleTag}
                  />
                </div>

                {/* Submit */}
                <ButtonComponent
                  type="submit"
                  className="w-full"
                >
                  Submit
                </ButtonComponent>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GoogleCustomeSetting;
